import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';

// Available wallpaper images
const mobileImages = [
  'mobile1.jpg', 'mobile2.jpg', 'mobile3.jpg', 'mobile4.jpg', 'mobile5.jpg',
  'mobile6.jpg', 'mobile7.jpg', 'mobile8.jpg', 'mobile9.jpg', 'mobile10.jpg',
  'mobile11.jpg', 'mobile12.jpg', 'mobile13.jpg', 'mobile14.jpg', 'mobile15.jpg',
  'mobile16.jpg', 'mobile17jpg', 'mobile18.jpg', 'mobile19.jpg', 'mobile20.jpg',
];

const desktopImages = [
  'desktop1.jpg', 'desktop2.jpg', 'desktop3.jpg', 'desktop4.jpg', 'desktop6.jpg',
  'desktop7.jpg', 'desktop8.jpg', 'desktop12.jpg', 'desktop13.jpg', 'desktop14.jpg',
  'desktop15.jpg', 'desktop17.jpg',
];

// Function to get random image from array
const getRandomImage = (images) => {
  const randomIndex = Math.floor(Math.random() * images.length);
  return `/gallery/${images[randomIndex]}`;
};

const HomePage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  // Randomly select background image on each page load and when screen size changes
  const [backgroundImage, setBackgroundImage] = useState(() => {
    return isSmallScreen 
      ? getRandomImage(mobileImages)
      : getRandomImage(desktopImages);
  });

  useEffect(() => {
    // Update background image when screen size changes
    setBackgroundImage(
      isSmallScreen 
        ? getRandomImage(mobileImages)
        : getRandomImage(desktopImages)
    );
  }, [isSmallScreen]);

  return (
    <Box>
      {/* Hero Section / Cover */}
      <Box
        sx={{
          position: 'relative',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          color: 'white',
          overflow: 'hidden',
        }}
      >
        {/* Dark overlay for text readability */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          }}
        />

        <Container 
          maxWidth="lg" 
          sx={{ 
            position: 'relative', 
            zIndex: 1, 
            textAlign: 'center', 
            py: { xs: 4, sm: 6, md: 8 },
            px: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Typography
            variant={isSmallScreen ? 'h4' : 'h2'}
            component="h1"
            sx={{
              fontWeight: 700,
              mb: { xs: 2, sm: 3 },
              textShadow: '0 2px 10px rgba(0,0,0,0.2)',
              fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
            }}
          >
            Daily Photo Calendar
          </Typography>
          <Typography
            variant={isSmallScreen ? 'body1' : 'h5'}
            component="p"
            sx={{
              mb: { xs: 3, sm: 4 },
              maxWidth: 600,
              mx: 'auto',
              opacity: 0.95,
              textShadow: '0 1px 5px rgba(0,0,0,0.2)',
              px: { xs: 2, sm: 0 },
              fontSize: { xs: '0.875rem', sm: '1.25rem' },
            }}
          >
            Capture your life, one day at a time. Create a visual diary of your journey with photos, memories, and daily reflections.
          </Typography>
          <Button
            variant="contained"
            size={isSmallScreen ? 'medium' : 'large'}
            onClick={() => navigate('/upload')}
            sx={{
              px: { xs: 3, sm: 4 },
              py: { xs: 1, sm: 1.5 },
              fontSize: { xs: '0.875rem', sm: '1.1rem' },
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            }}
          >
            Get Started
          </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default HomePage;

